module.exports = __webpack_public_path__ + "static/media/text-scale-icon.9439acd7.svg";